import { ComponentType, useCallback, useMemo, useState } from 'react';
import ModalPortal from '@alltrails/core/components/ModalPortal';

/**
 * @deprecated This doesn't actually save much, stop using it so we can delete it once we have all the modals from the monorepo ported to mugen
 */
const useModal = <
  P extends {
    closeModal: () => void;
    [key: string]: unknown;
  }
>(
  Component: ComponentType<P>,
  memoizedComponentProps: Omit<P, 'closeModal'>
) => {
  const [isOpen, toggleOpen] = useState(false);
  const [startingIndex, setStartingIndex] = useState<number | undefined>(undefined);

  const openModal = useCallback((idx?: number) => {
    if (idx) {
      setStartingIndex(idx);
    }
    toggleOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    toggleOpen(false);
  }, []);

  const modal = useMemo(() => {
    if (!isOpen) {
      return <></>;
    }

    const props = startingIndex !== undefined ? { ...memoizedComponentProps, startingIndex } : memoizedComponentProps;

    return (
      <ModalPortal>
        <Component {...(props as P)} closeModal={closeModal} />
      </ModalPortal>
    );
  }, [isOpen, Component, memoizedComponentProps, closeModal, startingIndex]);

  return { modal, openModal, closeModal };
};

export default useModal;
